// extracted by mini-css-extract-plugin
module.exports = {"root":"EventHero_root__hzXJa","hero":"EventHero_hero__LV4Ww","background":"EventHero_background__T7r0p"};